import React from 'react';
import styled from 'styled-components';
import { IMeasureFilterValue } from '../../../../../redux/slices/oldBuilder';
import { StyledSingleSelectOption } from '../../../../Dropdown/SingleSelect';

/**
 * When user doesn't have any active measure filter - we will show
 * this component where user should make a selection in order to
 * show non-empty Measure filter form
 */

interface IProps {
  options: IMeasureFilterValue[];
  onSelect: (measureKey: string) => void;
}

const Container = styled.div`
  overflow: hidden;
  min-width: 240px;
`;

const MeasureFilterDefaultView = ({ options, onSelect }: IProps) => {
  return (
    <Container>
      {options.map(({ measureKey }) => (
        <StyledSingleSelectOption
          key={`measure-filter-default-${measureKey}`}
          onClick={() => onSelect(measureKey)}
        >
          {measureKey}
        </StyledSingleSelectOption>
      ))}
    </Container>
  );
};

export default MeasureFilterDefaultView;
